export class BasicNewsEnvironment {
  public static getName = () => 'benzinga-basic-news';
  public static getEnvironment = (env: Record<string, string>) => ({
    chartBeatUrl: new URL(env.chartBeatUrl ?? 'https://www.benzinga.com/'),
    chartbeatKey: env.chartbeatKey ?? 'cd22f1d0cd5250f0d0cd080685999e69',
    esContentKey: env.spainContentKey ?? 'a762dfd3c5c44594a5c84d5f8f1cc133',
    frContentKey: env.franceContentKey ?? 'dccaedec0af64b20b05d474dffc02cce',
    itContentKey: env.italyContentKey ?? '307324ffa65044b385058db98f065e31',
    japanContentKey: env.koreaContentKey ?? 'f39c6e7ebd494879a5867a05bbf98e65',
    koreaContentKey: env.koreaContentKey ?? 'c7f27f3e068a42bf9a085e11f1c30cd6',
    nodeContentKey: env.oldQueryKey ?? 'a95054f9f5ce46698a0f4e388e487113',
    nodeContentSecKey: env.nodeContentSecKey ?? '49d996060a1041ba8ec307938b5f2702',
    nodeContentUrl: new URL(env.nodeContentUrl ?? 'https://api.benzinga.com/'),
    partnerContentKey: env.partnerContentKey ?? '5a3ef9a1e9ed4ce9893131ff6ff046f6',
    premiumArticlesUrl: new URL(env.premiumArticlesUrl ?? 'https://api.benzinga.com/'),
    pressReleaseKey: env.pressReleasesKey ?? '0412b9c929a045d6beea76a59408a9d2',
    simplyQueryUrl: new URL(env.simplyQueryUrl ?? 'https://www.benzinga.com/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
